/*
 * @Description: 商城-底部nav
 */
import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
import utils from 'utils';
import Config from 'config/Config';
import { observer, inject } from 'mobx-react';
import { routeAuthCodeMap } from 'utils/constants';
import { isHasRouteAuth } from 'utils/authUtil';
import { wechatLogin } from 'utils/wxUtils';
import cx from 'classnames';
import styles from './index.modules.less';
import { getIsUnsubscribeOrSleep } from 'biz-micro-services-ui/project/middlePlatform/function/globalState';

@inject('AppMod')
@observer
class FooterView extends Component {
  constructor(props, context) {
    super(props, context);

    // this.state = {
    // };
  }

  componentDidMount() {
    const { active } = this.props;
    const { userType } = this.props.AppMod;
    if (this.props.active == 4) {
      // 我的
      this.props.AppMod.changeState('isOnMineTab', true);
    } else {
      this.props.AppMod.changeState('isOnMineTab', false);
    }
    if (userType == 5 && active != 1) {
      window.app.routerRedirect('/store');
    }
  }

  get navList() {
    const { userType, storeInfo, userInfo, token } = this.props.AppMod;
    // memberStatus: 0-有效，1-未激活，2-未续约，3-注销，4-冻结 5-休眠期
    const { showShop, memberStatus, belongSystem } = this.props.AppMod.userInfo;
    const { authorizationStatus } = this.props.AppMod.storeInfo;
    // 子账号只有店铺入口
    return [
      {
        // ${CDN_BASE}/assets/imgs/bg/home_default.png
        name: '首页',
        img: 'icon-shopHome',
        aimg: 'icon-shopHome-select',
        link: '/',
        hidden: userType == 5,
        needLogin: false
      },
      {
        name: this.props.AppMod.isHiddenShop
          ? belongSystem && belongSystem === 'LY'
            ? '线下店'
            : '店铺'
          : belongSystem && belongSystem === 'LY'
            ? '线下店'
            : '服务中心',
        img: 'icon-shop',
        aimg: 'icon-shop-select',
        link: '/store',
        hidden: (() => {
          const isUnsubscribeOrSleep = getIsUnsubscribeOrSleep();
          if (isUnsubscribeOrSleep) return true;

          const noAuth = !isHasRouteAuth(routeAuthCodeMap.STOREENTRY_MAIN);
          const hasJointCreationTag = this.props.AppMod.hasJointCreationTag;
          const invalidUserType = hasJointCreationTag ? false : ![3, 5].includes(+userType);
          const invalidStoreStatus = hasJointCreationTag
            ? false
            : storeInfo.status == 2 || showShop === 0;
          const isMemberExpired = memberStatus == 2;
          const isLYUnauthorized = belongSystem === 'LY' && authorizationStatus !== 1;
          console.log(
            'isLYUnauthorized = ',
            noAuth || invalidUserType || invalidStoreStatus || isMemberExpired || isLYUnauthorized
          );
          return (
            noAuth || invalidUserType || invalidStoreStatus || isMemberExpired || isLYUnauthorized
          );
        })(),
        needLogin: true
      },
      {
        name: '展业',
        img: 'icon-shop-zhanye',
        aimg: 'icon-shop-zhanyeSelect',
        link: '/promote',
        // hidden: token ? memberStatus==2?true:((userType >= 2&&userType!='5') ? false : !!!userInfo.permitVirtualCard || userType == 5 || memberStatus == 2) : false,
        hidden: getIsUnsubscribeOrSleep()
          ? true
          : token && isHasRouteAuth(routeAuthCodeMap.EXHIBITION_ON_OFF)
            ? memberStatus == 2
              ? true
              : userType >= 2 && userType != '5'
                ? false
                : !userInfo.permitVirtualCard || userType == 5 || memberStatus == 2
            : true,
        needLogin: true
      },
      {
        name: '购物车',
        img: 'icon-shopCat',
        aimg: 'icon-shopCatSelect',
        link: '/shop/shoppingCart',
        hidden: userType == 5,
        needLogin: false
      },
      {
        name: '我的',
        img: 'icon-myShop',
        aimg: 'icon-myShop-select',
        link: '/personal',
        hidden: userType == 5,
        needLogin: false
      }
    ];
  }

  goTo = ({ link, needLogin }, index) => {
    if (index > 0 && !this.props.AppMod.token && needLogin) {
      utils.setLocalCache(Config.localStorageKeys.loginGoback, true);
      utils.setLocalCache(Config.localStorageKeys.registerRoute, '/shop/home');
      wechatLogin({
        redirectPath: link
      });
    } else {
      window.app.routerGoTo(link);
    }
  };

  render() {
    const { active } = this.props;

    return (
      <Flex justify="around" className={styles['footer_component']}>
        {this.navList.map((item, index) => {
          const { aimg, img, name, hidden } = item;
          if (hidden) return null;
          return (
            <Flex
              onClick={() => {
                this.goTo(item, index);
              }}
              className={styles['footer_item']}
              key={index}
              direction="column">
              <span
                className={cx('iconfont', styles['icon-bottom'], {
                  [aimg]: index == active,
                  [styles['icon-color']]: index == active,
                  [img]: index != active
                })}
              />
              <span
                className={cx({
                  [styles['active']]: index == active
                })}>
                {name}
              </span>
            </Flex>
          );
        })}
      </Flex>
    );
  }
}

export default FooterView;



// WEBPACK FOOTER //
// ./src/pubBiz/Footer/index.js